module.exports = __webpack_public_path__ + "img/price-request.c0471315.svg";